const SvgComponent = ({ svgJson }: { svgJson: string }) => {
	// Parse the JSON string into an object
	const svgObject = JSON.parse(svgJson);

	// Create a React SVG element using JSX syntax
	return (
    <svg
      width={svgObject.width}
      height={svgObject.height}
      viewBox={svgObject.viewBox}
      className="inline-block ml-3"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Set the attributes and content of the SVG element */}
      {svgObject.paths.map((path: any, index: number) => (
        <path
          key={index}
          d={path.d}
          fill={path.fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke={path.stroke}
          className={path.class !== '' || undefined ? path.class : null}
        />
      ))}
    </svg>
  );
};

export default SvgComponent;
